<template>
    <div class="bg-white rounded-xl shadow-lg p-6">
        <div class="flex items-center justify-between mb-6">
            <h3 class="text-lg font-semibold text-gray-800">Gender Distribution</h3>
            <div class="flex items-center space-x-4">
                <div class="flex items-center space-x-2">
                    <div class="w-3 h-3 bg-indigo-500 rounded-full"></div>
                    <span class="text-sm text-gray-600">Male</span>
                </div>
                <div class="flex items-center space-x-2">
                    <div class="w-3 h-3 bg-pink-500 rounded-full"></div>
                    <span class="text-sm text-gray-600">Female</span>
                </div>
            </div>
        </div>
        <apexchart type="donut" :options="chartOptions" :series="chartSeries" height="300" />
    </div>
</template>

<script>
export default {
    name: "GenderDistributionChart",
    props: {
        data: {
            type: Object,
            required: true,
            default: () => ({
                male: 0,
                female: 0,
                total: 0
            })
        }
    },
    computed: {
        chartSeries() {
            return [this.data.male, this.data.female];
        },
        chartOptions() {
            return {
                chart: {
                    type: 'donut',
                    toolbar: {
                        show: false
                    }
                },
                labels: ['Male', 'Female'],
                colors: ['#6366f1', '#ec4899'],
                legend: {
                    position: 'bottom',
                    formatter: (seriesName, opts) => {
                        const value = opts.w.globals.series[opts.seriesIndex];
                        const percentage = ((value / this.data.total) * 100).toFixed(1);
                        return `${seriesName} - ${value} (${percentage}%)`;
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val.toFixed(1) + '%';
                    },
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold'
                    }
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '60%',
                            labels: {
                                show: true,
                                total: {
                                    show: true,
                                    label: 'Total',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    color: '#263238'
                                }
                            }
                        }
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + ' graduates';
                        }
                    }
                }
            };
        }
    }
};
</script>

<style scoped>
/* Component-specific styles can be added here */
</style>